import * as React from "react";

import type {ColumnProps} from "./types.ts";

/**
 * Column Component for both Table and SortableTable.
 */
// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component -- moved an old file
export default class Column extends React.Component<ColumnProps> {
    // @ts-expect-error - TS2564 - Property 'type' has no initializer and is not definitely assigned in the constructor.
    type: {
        name: string;
    };

    render(): React.ReactNode {
        return null;
    }
}
